import Component from '../../component/component';

import './textfield.scss';

export default class Textfield extends Component {
    static initSelector: string = '.textfield';

    input: HTMLInputElement;
    button: HTMLElement;
    dirtyClass: string;
    focusClass: string;

    constructor(target: HTMLElement) {
        super(target);

        this.input = this.element.querySelector('.textfield__input');
        this.button = this.element.querySelector('.textfield__password-button');
        this.focusClass = 'is-focused';
        this.dirtyClass = 'is-dirty';

        this.init();
    }

    init(): void {
        if (this.button) {
            this.button.addEventListener('click', this.toggle.bind(this));
        }
        if (this.input) {
            this.input.addEventListener('focus', this.onFocus.bind(this));
            this.input.addEventListener('blur', this.onBlur.bind(this));
            this.input.addEventListener('input', this.onChange.bind(this));
            this.element.addEventListener('onautocomplete', () => {
                this.element.classList.add('is-dirty');
            });
            this.checkValue();
        }
    }

    toggle(): void {
        if (this.element.classList.contains('is-visible')) {
            this.element.classList.remove('is-visible');
        } else {
            this.element.classList.add('is-visible');
        }

        this.changeType();
    }

    changeType(): void {
        if (this.input.type === 'password') {
            this.input.type = 'text';
        } else {
            this.input.type = 'password';
        }
    }

    onFocus(): void {
        this.element.classList.add(this.focusClass);
    }

    onBlur(): void {
        this.checkValue();
        setTimeout((): void => {
            this.element.classList.remove(this.focusClass);
        }, 100);
    }

    onChange(): void {
        this.checkValue();
    }

    checkValue(): void {
        if (this.input.value === '') {
            this.element.classList.remove(this.dirtyClass);
        } else {
            this.element.classList.add(this.dirtyClass);
        }
    }
}
